import './reactions_client.js.coffee'

class Customer.Interaction extends Backbone.Model
  urlRoot: '/customer/dashboard'

  defaultSocialAccountId: ->
    selectedSocialAccountId = $('#social_accounts').val()
    return selectedSocialAccountId if selectedSocialAccountId
    socialAccounts = @get('socialAccounts')
    socialAccount = _.find socialAccounts, (element) -> element.is_preferred
    socialAccount && socialAccount.id

  updateTags: (tags) ->
    params = 'interaction': {'id': @get('socialContentId'), 'tags': tags, 'status': @_getStatus(tags)}

    $.ajax
      url: '/customer/interactions/update.json'
      type: 'POST'
      global: false
      data: params
      dataType: 'json'
      success: (response) =>
        if response.success
          @trigger('interaction:update:success', response)
        else
          @trigger('interaction:update:error', response)
        Backbone.trigger('interaction:update')
      error: (response) =>
        @trigger('interaction:update:error', response)

  follow: () ->
    $.post(
      "#{@urlRoot}/follow.json"
      @_defaultAjaxParams()
      (response) => @trigger('interaction:follow')
    )

  retweet: () ->
    $.post(
      "#{@urlRoot}/retweet.json"
      @_defaultAjaxParams()
      (response) => @trigger('interaction:retweet', response)
    )

  favorite: () ->
    $.post(
      "#{@urlRoot}/favorite.json"
      @_defaultAjaxParams()
      (response) => @_manageResponse(response, 'interaction:favorite')
    )

  like: () ->
    $.post(
      "#{@urlRoot}/like"
      @_defaultAjaxParams()
      (response) => @_manageResponse(response, 'interaction:like')
    )

  unLike: () ->
    $.post(
      "#{@urlRoot}/unlike"
      @_defaultAjaxParams()
      (response) => @_manageResponse(response, 'interaction:unLike')
    )

  react: ->
    client = new Customer.ReactionsClient(@)
    client.react(@defaultSocialAccountId())

  unreact: ->
    client = new Customer.ReactionsClient(@)
    client.unreact(@defaultSocialAccountId())

  _manageResponse: (response, eventName) ->
    if response.success then @trigger(eventName) else window.showError(response.message)

  _defaultAjaxParams: () ->
    interaction_id: @get('interactionId')
    social_account_id: @defaultSocialAccountId()
    conversation_id: @get('conversation').get('id')

  _getStatus: (tags) =>
    if _.any(tags, (code) => @impliesRejection(code))
      'REJECTED'
    else
      'APPROVED'

  impliesRejection: (code) ->
    _.find(@get('possibleTags'), (tag) -> tag.code == code)?.implies_rejection

  followingAuthor: ->
    (@authorInfo || {}).following

  loadAuthorInfo: ->
    return if @authorInfo
    # $.get(
    #   "/customer/interactions/#{@get('interactionId')}/author_info.json"
    #   @_defaultAjaxParams()
    #   (authorInfo) => @trigger('interaction:author_info:loaded', @authorInfo = authorInfo)
    # )
    @trigger('interaction:author_info:loaded', @authorInfo = {})

class Customer.InteractionsCollection extends Backbone.Collection
  model: Customer.Interaction
